<template lang="pug">
    include ../../media/pug/mixins.pug
    +b.mark-editor(
        v-show="isVisible"
        v-bind:style="{bottom: `${offset}px`}"
    )
        +e.inner
            +e.INPUT.input.input(
                type="text"
                v-model="value"
                placeholder="Добавить комментарий"
                v-on:keyup.enter="changeText"
            )
            +e.BUTTON.delete.btn.btn_icon(
                v-if="isMarkEditMode"
                v-on:mousedown="remove"
                v-on:touchstart="remove"
                type="button"
            )
                v-icon(name="trash")
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false,
            required: true
        }
    },
    data() {
        return {
            offset: 0,
            value: ''
        };
    },
    computed: {
        ...mapGetters([
            'isMenuPanelVisible',
            'getActiveMark',
            'getActiveArea',
            'getAreas',
            'getMarks',
            'isMarkEditMode',
            'isMarkConfirmed',
            'isMobile'
        ]),
        activeMark() {
            return [this.getActiveMark, this.getActiveArea];
        }
    },
    watch: {
        isMenuPanelVisible: {
            immediate: true,
            handler(val) {
                if (val) {
                    this.offset = document.querySelector('.menu-panel__section_navigation').clientHeight;
                } else {
                    this.offset = 0;
                }
            }
        },
        activeMark: {
            immediate: true,
            handler(val) {
                const [mark, area] = val;
                if (mark) {
                    this.value = mark.text;
                } else if (area) {
                    this.value = area.text;
                } else {
                    this.value = '';
                }
            }
        },
        isMarkConfirmed(val) {
            if (val && this.isVisible) {
                this.changeText();
            }
        }
    },
    methods: {
        remove() {
            this.$store.dispatch('showModal', 'ModalRemoveMark');
        },
        changeText() {
            this.$emit('change-text', this.value);
        }
    }
};
</script>

<style lang="sass" src="@/media/sass/components/document-views/document-view-img-mark-editor.sass"></style>
